﻿export class StringUtils {
	public static format(template: string, ...args: any[]): string {
		return template.replace(/{(\d+)}/g, function (match, number) {
			return typeof args[number] != 'undefined' ? args[number] : match;
		});
	}
}
